// src/firebase.js
// Filepath: // src/firebase.js
import { initializeApp, getApps, getApp } from "firebase/app";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getStorage, connectStorageEmulator } from "firebase/storage";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

// Initialize once (fixes app/no-app on /pair route)
const app = getApps().length ? getApp() : initializeApp(firebaseConfig);

// Region for Cloud Functions
const functionsRegion = process.env.REACT_APP_FIREBASE_FUNCTIONS_REGION || "us-central1";

// Export services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app, functionsRegion);

// Optional: connect to local emulators during dev
const useEmulators = (process.env.REACT_APP_USE_EMULATORS || "").toLowerCase() === "true";

if (useEmulators) {
  try {
    connectAuthEmulator(auth, `http://localhost:${process.env.REACT_APP_FIREBASE_EMULATOR_AUTH_PORT || 9099}`, {
      disableWarnings: true,
    });
  } catch {}
  try {
    connectFirestoreEmulator(db, "localhost", Number(process.env.REACT_APP_FIREBASE_EMULATOR_FIRESTORE_PORT || 8080));
  } catch {}
  try {
    connectStorageEmulator(storage, "localhost", Number(process.env.REACT_APP_FIREBASE_EMULATOR_STORAGE_PORT || 9199));
  } catch {}
  try {
    connectFunctionsEmulator(functions, "localhost", Number(process.env.REACT_APP_FIREBASE_EMULATOR_FUNCTIONS_PORT || 5001));
  } catch {}
}

export default app;
